import CardStyles from "@/components/Card/Card.module.css";
import ShipmentBoxStyles from "../ShipmentBox/ShipmentBox.module.css";

export function oneTimeDragNDropInit(draggingState: DraggingState) {

  window.requestAnimationFrame(() => { loop(); });

  document.body.addEventListener("pointermove", function(e) {
    if(draggingState.isDragging) {
      const drags = document.querySelectorAll("[data-drag-item-id]");
      if(!drags.length) {
        doneDraggingAt(draggingState, e.clientX, e.clientY);
        return;
      }
      for(const drag_ of drags) {
        let drag = drag_ as HTMLElement;
        let p = getDragP(e);
        drag.style.left = p.x + "px";
        drag.style.top = p.y + "px";
        draggingState.isDragging = true;
      }

      const drops = document.querySelectorAll("[data-box-id-prep-n-boxem]");
      let drop = getClosestElementInList(e.clientX, e.clientY, drops);
      for(const d of drops) {
        if(d != drop && d.classList.contains(CardStyles.boxHoveringWhenDragging)) d.classList.remove(CardStyles.boxHoveringWhenDragging);
        d.querySelector(".allBoxesForDragNDrop").setAttribute("data-target-box-frame-for-drag-n-drop", BOX_FRAME_OPEN.toString());
      }
      if(drop) {
        // @NOTE(michaelp): A very funny side effect of putting this in mousemove
        // that I really want to keep is that the animation stops restarting if you stop moving your mouse,
        // then it will keep going once you move again. This is amazing and the best possible behavior.
        // It is like the box is eagerly watching you.

        // @NOTE(michaelp): Play animation if able, otherwise waits until animation is marked to end
        {
          /* @NOTE(michaelp)(pozoid): Animation duration in two places search codebase for "pozoid" */
          const bounceDuration = 0.75;
          const bounceClassName = ShipmentBoxStyles.bounceBoxIconChild;
          const bounceAllowOverrideAfterPercent = 0.95; // It multiplies duration by this to find when we can next override the animation
          const e = drop.querySelector("." + ShipmentBoxStyles.boxIcon);
          if(!e) {
            console.warn("No Shipment Box Icon child");
            return;
          }
          let animationEnds = parseFloat(e.getAttribute("data-animation-ends"));
          if(isNaN(animationEnds)) animationEnds = -10000;
          const now = performance.now();
          if(now >= animationEnds) {
            e.classList.remove(bounceClassName);
            window.requestAnimationFrame(function() {
              e.classList.add(bounceClassName);
            });
            e.setAttribute("data-animation-ends", now + (bounceAllowOverrideAfterPercent*bounceDuration*1000.0));
          }
        }

        if(drop && !drop.classList.contains(CardStyles.boxHoveringWhenDragging)) drop.classList.add(CardStyles.boxHoveringWhenDragging);
      }
    }
  });
  document.body.addEventListener("pointerup", function(e) {
    if(draggingState.isDragging) {
      doneDraggingAt(draggingState, e.clientX, e.clientY);
    }
  });

}

export type DraggingState = {
  isDragging?: boolean;
  // @NOTE(michaelp): Functions the current dragging item set
  onDropInBox?: (boxId: number) => void;
  onCancelOrDone?: () => void;
};

type V2 = { x: number, y: number };
type Rect = { min: V2, max: V2 };
function dot(a: V2, b: V2): number { return a.x*b.x + a.y*b.y };
function lenSq(a: V2): number { return dot(a,a); }
function len(a: V2): number { return Math.sqrt(lenSq(a)); }
function sub(a: V2, b: V2): V2 { return {x: a.x - b.x, y: a.y - b.y }; }
function dist(a: V2, b: V2): number { return len(sub(a,b)); }
function distanceToRectangle(p: V2, rect: Rect, scaleXDistanceOnLeftWall: number = 1.0) {
  // Top/bottom walls
  if(p.x >= rect.min.x && p.x <= rect.max.x) {
    if(p.y >= rect.max.y) return Math.abs(p.y - rect.max.y);
    if(p.y <= rect.min.y) return Math.abs(p.y - rect.min.y);
  }
  // Left/right walls
  if(p.y >= rect.min.y && p.y <= rect.max.y) {
    if(p.x <= rect.min.x) return Math.abs(scaleXDistanceOnLeftWall*(p.x - rect.min.x));
    if(p.x >= rect.max.x) return Math.abs(p.x - rect.max.x);
  }
  // Corners
  let xy = rect.min;
  let XY = rect.max;
  let xY = {x: rect.min.x, y: rect.max.y };
  let Xy = {x: rect.max.x, y: rect.min.y };
  if(p.x <= xy.x && p.y <= xy.y) return dist({x:xy.x + scaleXDistanceOnLeftWall*(p.x - xy.x), y:p.y},xy);
  if(p.x >= XY.x && p.y >= XY.y) return dist(p,XY);
  if(p.x >= Xy.x && p.y <= Xy.y) return dist(p,Xy);
  if(p.x <= xY.x && p.y >= xY.y) return dist({x:xy.x + scaleXDistanceOnLeftWall*(p.x - xy.x), y:p.y},xY);
  // Inside
  return 0;
}
function getClosestElementInList(x,y,list) {
  const tooFar = 100; // pixels

  let p: V2 = {x,y};
  let drop = undefined;
  let dropDistance = tooFar;
  for(const test of list) {
    let r = test.getBoundingClientRect();
    let testRect: Rect = {min: {x:r.x, y:r.y}, max: {x:r.x+r.width, y:r.y+r.height}};
    let testDistance: number = distanceToRectangle(p, testRect, 3);
    if(testDistance <= dropDistance) {
      dropDistance = testDistance;
      drop = test;
    }
  }
  return drop;
}

const INVALID_DRAG_P = -1337;
function getDragP(e) { return {x: e.clientX ?? e.targetTouches?.[0].clientX ?? INVALID_DRAG_P, y: e.clientY ?? e.targetTouches?.[0].clientY ?? INVALID_DRAG_P }; }

const BOX_FRAME_OPEN = 4;
const BOX_FRAME_CLOSED = 1;
function loop() {
  let elements = document.querySelectorAll("[data-target-box-frame-for-drag-n-drop]");
  if(elements.length) {
    const now = performance.now();
    for(const e of elements) {
      let initialFrame = e.getAttribute("data-box-frame-for-drag-n-drop");
      let frame = parseInt(initialFrame);
      if(isNaN(frame)) frame = 0;
      let target = parseInt(e.getAttribute("data-target-box-frame-for-drag-n-drop"));
      let waitTill = parseInt(e.getAttribute("data-wait-to-set-next-frame"));
      const FPS = 16;
      const nextFrameTime = now + (1000.0/FPS);
      if(isNaN(waitTill)) {
        e.setAttribute("data-wait-to-set-next-frame", nextFrameTime.toString());
      } else if(now >= waitTill) {
        let frameWas = frame;
        if(frame < target) frame += 1;
        if(frame > target) frame -= 1;
        if(frame != frameWas) {
          for(let i_ in e.children) {
            let i: number = parseInt(i_);
            if(!isNaN(i)) {
              const frameZeroIndexed = frame - 1;
              const child = e.children[i] as HTMLElement;
              if(i == frameZeroIndexed) child.style.opacity = "1";
              else child.style.opacity = "0";
            }
          }
          e.setAttribute("data-box-frame-for-drag-n-drop", frame.toString());
        }
        if(frame == target) {
          e.removeAttribute("data-target-box-frame-for-drag-n-drop");
        }
        e.setAttribute("data-wait-to-set-next-frame", nextFrameTime.toString());
      }
    }
  }
  window.requestAnimationFrame(loop);
}

function doneDraggingAt(draggingState: DraggingState, x,y) {
  const drags = document.querySelectorAll("[data-drag-item-id]");
  const drops = document.querySelectorAll("[data-box-id-prep-n-boxem]");
  let drop = getClosestElementInList(x, y, drops);
  if(drop) {
    let id = drop.getAttribute("data-box-id-prep-n-boxem");
    if(id && draggingState.onDropInBox) {
      draggingState.onDropInBox(id);
    }
  }
  for(const drag of drags) drag.remove();
  for(const d of drops) {
    d.classList.remove(CardStyles.boxHoveringWhenDragging);
    d.querySelector(".allBoxesForDragNDrop").setAttribute("data-target-box-frame-for-drag-n-drop", BOX_FRAME_CLOSED.toString());
  }
  draggingState.isDragging = false;
  if(draggingState.onCancelOrDone) draggingState.onCancelOrDone();
  document.body.classList.remove("amDraggingNDroppingGiveCursor");
}
